import { constants } from '@bedc/constants';

import { Request } from '../../../../api/user/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const UserType = SearchDataTableType({
	request: Request,
	columnFields: constants.user.search.columnFields,
	filterIds: constants.user.search.filterFields,
});
